import React, { useEffect } from 'react'
import {MediaShowcase,IncludedSection,PricingSection,CallbackForm,IncludeSection} from '../../components/template';
const Book = () => {



    const accomodateItems=[
        { type: "image", src: "/assets/accomodation/a1.jpg" },
        { type: "image", src: "/assets/accomodation/a13.jpg" },
        { type: "image", src: "/assets/accomodation/a2.jpg" },


        { type: "image", src: "/assets/accomodation/a3.jpg" },
        { type: "image", src: "/assets/accomodation/a4.jpg" },
        { type: "image", src: "/assets/accomodation/a5.jpg" },
                { type: "image", src: "/assets/accomodation/a11.jpg" },


        { type: "image", src: "/assets/accomodation/a7.jpg" },
        { type: "image", src: "/assets/accomodation/a8.jpg" },
                { type: "image", src: "/assets/accomodation/a6.jpg" },

      ]
      const whatsInclHeading = "What’s Included?";
const whatsInclMainImage = "/assets/synnergise/mincl.jpg";

const whatsInclItems = [
  {
    icon: "🏡",
    heading: "Comfortable Stay & Nourishing Meals",
    points: [
      "3 nights, 4 days in cottages or Swiss tents, nestled in the serene Himalayan landscape",
      "Wholesome, sattvic meals curated to energize and detox your body",
    ],
  },
  {
    icon: "🌱",
    heading: "Holistic Wellness & Life Coaching",
    points: [
      "Interactive sessions on well-being, Ayurveda, and mindful living",
      "Life coaching & self-discovery exercises to help you gain clarity and purpose",
    ],
  },
  {
    icon: "🧘",
    heading: "Yoga & Meditation",
    points: [
      "Morning and evening yoga sessions to restore balance and flexibility",
      "Guided meditation to calm the mind and deepen self-awareness",
    ],
  },
  {
    icon: "🎉",
    heading: "Nature & Fun Activities",
    points: [
      "Guided Himalayan treks to reconnect with nature and refresh your soul",
      "Engaging group activities & bonding experiences for a truly memorable retreat",
    ],
  },
];


      const whatsIncludedHeading = "What’s Included?";
      const whatsIncludedMainImage = "/assets/synnergise/mincl.jpg"; 
      const whatsIncludedOverlayImage = "/assets/synnergise/sincl.jpg";
      const whatsIncludedItems = [
        { icon: "🏡", title: " Cozy & Comfortable Stay " },
        { icon: "🥗", title: "Nourishing Delicious Veg Meals"},
        { icon: "🧘", title: "Daily Yoga & Meditation", },
        { icon: "💨", title: "Physical & Mental Detox",  },
        { icon: "🧠", title: " Positive Mindset & Habit Building",  },
        { icon: "⛰️", title: " Nature Hike and Trek " },
        { icon: "🔥", title: " Bonfire and Games " },
        { icon: "🚐", title: " Pick-up & Drop from Rishikesh " },

      ];
      const pricingData = {
        title: "Pricing Details",
        packages: [
          { name: "Cottage – Single Occupancy", standardPrice: "35,999", discountedPrice: "29,999" },
          { name: "Swiss Tent – Single Occupancy", standardPrice: "34,999", discountedPrice: "28,999" },
          { name: "Cottage – Twin Sharing", standardPrice: "25,999", discountedPrice: "19,999" },
          { name: "Swiss Tent – Twin Sharing", standardPrice: "24,999", discountedPrice: "18,999" }
        ],
        offers: [
          // { label: "10% off – when you book before April 31st, 2025", discount: 0.10, validUntil: "2025-04-30T23:59:59" },
          // { label: "15% off – for booking for 2 or more people", discount: 0.15, minQuantity: 2 },
          // …etc.
        ]
        
      };
          
      const validCoupons = {
        // DISCOUNT10: 0.10,
        // SAVE20: 0.20,
        // add more coupon codes as needed
      };
    
  return (
<>
         <PricingSection data={pricingData} validCoupons={validCoupons} dueDate="07/02/2026"
     program="Innergise Retreat 14th-17th February 2026"
         />

<section className="py-8 bg-accent">
        <div className="container mx-auto px-4">
          <h2 className="mb-3 text-center text-lg md:text-3xl font-bold text-secondary" >Checkout Your Accomodation</h2>
          <h2 className="mb-5 text-center text-md md:text-xl font-bold text-secondary" >📌 Sahaja Retreat,Rishikesh, Uttarakhand</h2>

          <MediaShowcase
                mediaItems={accomodateItems} // Only images
                showVideo={false} // Disable videos
          
          />
        </div>
      </section>
      <div className='bg-white p-2 md:p-6'>
              <IncludeSection
        mainImage={whatsInclMainImage}
        heading={whatsInclHeading}
        items={whatsInclItems}
      />
{/* <IncludedSection heading={whatsIncludedHeading}
      mainImage={whatsIncludedMainImage}
      overlayImage={whatsIncludedOverlayImage}
      items={whatsIncludedItems}/> */}
      </div>
         <section className="py-8 bg-[#F1E5D9] align-center text-center text-sm md:text-lg  items-center">
<a href='/SYNNERGISE Brochure_2025.pdf' className="text-secondary hover:text-primary underline cursor-pointer font-semibold">
Download Brochure</a>
</section>

  <CallbackForm />

</>  )
}

export default Book;